import { MonitoringTopicPage } from '@features/monitoringOffer';

export const MonitoringTopic = () => {
	return (
		<div className="w-full h-full max-w-[1440px] mx-auto px-5">
			<MonitoringTopicPage />
		</div>
	);
};
